import { Injectable, inject } from '@angular/core'
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
} from '@angular/router'
import { CommonService } from '../services/common.service'
import {
  AuthService,
  AuthStorageService,
  GlobalMessageService,
  GLOBAL_MESSAGE_FEATURE,
  GlobalMessageType,
  AuthToken,
  UserIdService,
  OCC_USER_ID_CURRENT,
  AuthActions,
} from '@spartacus/core'
import { VSAuthService } from './auth.service'
import { take } from 'rxjs/operators'
import moment from 'moment'
import { Store } from '@ngrx/store'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { GoogleTagManagerService } from '../../shared/services/gtm.service';
import { GtmEvents, LoginMethod } from '../../shared/enums/gtm.enum';

@Injectable({ providedIn: 'root' })
export class CustomAuthGuardClass {
  asyncLocalStorage = {
    getItem: function (key) {
      return Promise.resolve().then(function () {
        return localStorage.getItem(key)
      })
    },
  }
  constructor(
    private router: Router,
    private commonService: CommonService,
    private authService: AuthService,
    private globalMessageService: GlobalMessageService,
    private vsAuthService: VSAuthService,
    private activeCartFacade: ActiveCartFacade,
    private multiCartFacade: MultiCartFacade,
    private authStorageService: AuthStorageService,
    private userIdService: UserIdService,
    protected store: Store,
    protected gtmService: GoogleTagManagerService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authCode = route.queryParams['code']
    const token: AuthToken = {
      access_token: '',
      access_token_stored_at: '',
    }
    if (authCode) {
      const urlParams = ['vslogin', 'token', authCode]
      const authTokenURL = this.commonService.constructUrl(urlParams)
      let accessToken = ''

      // Test Data
      /* const tempUserToken: any = {
        access_token: '47d64764-4b06-4ae8-9480-e34f0282df12',
        token_type: 'bearer',
        refresh_token: 'd6f2528f-3478-4bb1-8940-b243f2f07cf3',
        expires_in: 43199,
        scope: 'basic openid',
        userId: 'b2b@bh.com'
      };

      token.access_token = tempUserToken.access_token;
      token.token_type = tempUserToken.token_type;
      token.refresh_token = tempUserToken.refresh_token;
      token.expires_in = tempUserToken.expires_in;
      token.scope = tempUserToken.scope.split(' ');
      token.userId = tempUserToken.userId; */

      this.commonService.getData_WithoutRetry(authTokenURL).subscribe(
        (authData: any) => {
          if (authData) {
            accessToken = authData?.access_token
            token.access_token = authData.access_token
            token.token_type = authData.token_type
            token.refresh_token = authData.refresh_token
            token.expires_at = authData.expires_in
            token.granted_scopes = authData.scope.split(' ')
            // token.userId = authData.userId
            const date = new Date()
            const expirationTime = moment(date)
              .add(token.expires_at, 's')
              .toDate()
            // date.setSeconds(date.getSeconds() + token.expires_in);
            token.access_token_stored_at = '' + Date.now()
            // token.expiration_time = expirationTime.toJSON()

            if (accessToken) {
              this.authStorageService.setToken(token)
              this.userIdService.setUserId(OCC_USER_ID_CURRENT)
              this.store.dispatch(new AuthActions.Login())

              const params = ['users', 'current', 'myprofile']
              const apiUrl = this.commonService.constructUrl(params)
              this.commonService.getData(apiUrl).subscribe(
              (success) => {
                this.gtmService.sendEvent({
                  event: GtmEvents.Login,
                  authentication_method: LoginMethod.Okta,
                  user_id: success["email"],
                  userType: 'current',
                });
              })
              this.activeCartFacade.getActiveCartId().subscribe((res) => {
                if (res) {
                  this.multiCartFacade.loadCart({
                    userId: 'current',
                    cartId: res,
                    extraData: {
                      active: true,
                    },
                  })
                }
              })
              this.asyncLocalStorage.getItem('lastURL').then((data) => {
                if (data) {
                  localStorage.removeItem('lastURL')
                  this.router.navigateByUrl(data)
                } else {
                  this.router.navigateByUrl('homepage')
                }
              })
            } else if (accessToken == undefined || accessToken == '') {
              this.gtmService.sendEvent({
                event: GtmEvents.LoginError,
                authentication_method: LoginMethod.Okta
              });

              this.vsAuthService.setDeliveryGroupErrors({
                code: 2001,
              })
              return true
            }
          } else {
            this.gtmService.sendEvent({
              event: GtmEvents.LoginError,
              authentication_method: LoginMethod.Okta
            });

            this.vsAuthService.setDeliveryGroupErrors({
              code: 2001,
            })
            return true
          }
        },
        (er) => {
          this.gtmService.sendEvent({
            event: GtmEvents.LoginError,
            authentication_method: LoginMethod.Okta
          });

          if (er.error?.errors[0]?.reason == '2000') {
            this.vsAuthService.setDeliveryGroupErrors({
              code: 2000,
            })
            return true
          } else if (er.error?.errors[0]?.reason == '2001') {
            this.vsAuthService.setDeliveryGroupErrors({
              code: 2001,
            })
            return true
          } else {
            this.globalMessageService.add(
              { key: 'sharedComponents.loginFailed' },
              /* 'Login failed due a technical issue. Please try again later or contact customer care', */
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            this.router.navigate(['/login'])
            return true
          }
        }
      )
    } else {
      this.gtmService.sendEvent({
        event: GtmEvents.LoginError,
        authentication_method: LoginMethod.Okta
      });

      this.globalMessageService.add(
        { key: 'sharedComponents.accountDisabled' },
        /* 'Account has been disabled', */
        // 'Login failed due a technical issue, authorization code not found. Please try again later or contact customer care',
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      )
      this.router.navigate(['/login'])
    }
    return true
  }
}

export const CustomAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(CustomAuthGuardClass).canActivate(route, state)
}
